import React from 'react';

import PropTypes from 'prop-types';
import { req } from 'react-reqq-lite';
import cn from 'classnames';
import { Link } from 'react-router-dom';
// import { FaBell } from 'react-icons/fa';
import { BsFillTelephoneFill } from 'react-icons/bs';
import { HiMenuAlt2, HiOutlineLogout } from 'react-icons/hi';
import { isEmpty } from 'lodash';

import { Avatar } from 'modules/common/Img';
import { Button } from 'modules/common/input';
import PopUp from 'modules/common/components/PopUp';
import { BreadNav } from 'modules/common/components/Breaded';
import { showModal } from 'modules/common/modal';
import ContactUsModal from 'modules/contact-us/containers/ContactUs';
import { jsUcFirst } from 'modules/common/utils';

import { AUTH_PROFILE, AUTH_TYPE } from '../constants';
import Notification from './Notification';

export const UserType = ({ data, withLoggedInLabel, titleClassName }) => {
  const authProfile = React.useContext(AUTH_PROFILE);
  const authType = React.useContext(AUTH_TYPE);

  return (
    <div className="flex flex-col items-end text-xs leading-tight max-w-[200px] md:max-w-none">
      <div className={cn('uppercase font-bold truncate', titleClassName)}>
        {(isEmpty(data) ? authProfile : data)?.business_name}{' '}
        {(isEmpty(data) ? authProfile : data)?.business_name?.length > 0 &&
          (isEmpty(data) ? authProfile : data)?.branch_name?.length > 0 &&
          ' - '}
        <span>
          {(isEmpty(data) ? authProfile : data)?.branch_name &&
            `${(isEmpty(data) ? authProfile : data)?.branch_name}`}
        </span>
      </div>
      <div className="truncate">
        {withLoggedInLabel && 'Logged in as '}
        {jsUcFirst(isEmpty(data) ? authType : data?.authType)} Admin
      </div>
    </div>
  );
};

UserType.defaultProps = {
  data: {},
  titleClassName: '',
  withLoggedInLabel: true,
};

UserType.propTypes = {
  data: PropTypes.instanceOf(Object),
  withLoggedInLabel: PropTypes.bool,
  titleClassName: PropTypes.string,
};

function Header({ data }) {
  const authType = React.useContext(AUTH_TYPE);
  const [showDropdown, setShowDropdown] = React.useState(false);

  const handleOnSideOpenBar = (e) => {
    e.preventDefault();
    req.set('SIDEBAR', true);
  };

  const name = React.useMemo(() => {
    const { first_name, last_name } = data;
    const a = first_name ? first_name?.split(' ')[0] : 'Admin';
    const b = last_name ? last_name?.split(' ')[0] : 'User';
    return `${a} ${b}`;
  }, [data]);

  const handleOnContactUs = () => {
    showModal({
      title: 'Contact Us',
      content: (onClose) => <ContactUsModal onClose={onClose} isModal />,
      modalSize: 'modal-xs',
    });
  };

  return (
    <div
      className={cn(
        'bg-white border-b w-full border-gray-100 shadow-sm relative',
        showDropdown ? 'z-[31] md:z-20' : 'z-20'
      )}
    >
      <div className="px-3 md:px-6 py-3 flex items-center">
        <div className="hidden lg:block">
          <BreadNav />
        </div>
        <div className="block lg:hidden -ml-3">
          <Button
            onClick={handleOnSideOpenBar}
            className="btn sm light"
            label={<HiMenuAlt2 className="w-6 h-6" />}
          />
        </div>
        <div className="flex items-center gap-3 ml-auto">
          {/* <div className="xs:w-44 w-64 md:w-72"> */}
          {/* TODO: Partial input for module search intellisense, make this smart component */}
          {/* <FormInputSearch name="intellisense" className="py-2" /> */}
          {/* </div> */}
          {/* <div> */}
          {/* <span className="text-gray-400 transition ease-in-out duration-300 hover:text-gray-500 cursor-pointer"> */}
          {/* <FaBell className="h-6 w-6" /> */}
          {/* </span> */}
          {/* </div> */}

          {/* {authType !== 'ADMIN' && <Notification />} */}
          {authType !== 'ADMIN' && authType !== 'PARTNER' && (
            <>
              <UserType />

              <Notification
                showDropdown={showDropdown}
                setShowDropdown={setShowDropdown}
              />
            </>
          )}

          <PopUp
            autoClose
            positionClassName="-mt-1 -ml-44"
            buttonClassName="flex items-center gap-3"
            sizeClassName="w-52"
            containerClassName="!w-auto md:!w-full"
            render={
              <Avatar
                name={name}
                src={data?.photo || ''}
                className="object-cover rounded-full"
                color="#ae1818"
                size="30px"
              />
            }
          >
            <div className="py-1 divide-y" role="none">
              {authType === 'MERCHANT' && (
                <Button
                  onClick={handleOnContactUs}
                  className="group flex items-center w-full text-left px-3 py-1 text-gray-500 hover:bg-gray-100 hover:text-primary-500 gap-2 font-medium"
                  label={
                    <>
                      <BsFillTelephoneFill className="h-4 w-5 text-gray-500 group-hover:text-primary-500" />
                      <span>Contact Us</span>
                    </>
                  }
                />
              )}
              <Link
                to="/logout"
                className="group flex items-center w-full text-left px-3 py-1 text-gray-500 hover:bg-gray-100 hover:text-primary-500 gap-2 font-medium"
              >
                <HiOutlineLogout className="h-5 w-5 text-gray-500 group-hover:text-primary-500" />
                <span>Sign out</span>
              </Link>
            </div>
          </PopUp>
        </div>
      </div>
      <div className="sticky top-0 block lg:hidden border-t border-gray-200">
        <div className="px-3 md:px-6 py-3 flex items-center">
          <BreadNav />
        </div>
      </div>
    </div>
  );
}

Header.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default React.memo(Header);
